import React from 'react';
import { TopBanner } from '../components/TopBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { DeviceMarketplace } from '../components/DeviceMarketplace';
export function Shop() {
  return <div className="min-h-screen bg-white dark:bg-[#000000] text-[#333333] dark:text-gray-100 transition-colors duration-300" data-id="element-759" data-mp="sdkf89a8k91">
      <TopBanner data-id="element-760" data-mp="349vkuumq6ozf" />
      <Navbar data-id="element-761" data-mp="349c7zsbxmqs9" />
      <main className="pt-[133px]" data-id="element-762" data-mp="34ax43mdwahs8">
        <div className="py-20 text-center bg-[#13E200] dark:bg-[#090D1A]" data-id="element-763" data-mp="347sug9hnutu6">
          <h1 className="text-5xl font-black tracking-tighter text-black dark:text-white uppercase" data-id="element-764" data-mp="2zcdijn37r80e">
            Shop Devices
          </h1>
        </div>
        <DeviceMarketplace data-id="element-765" data-mp="3998dxx46wsag" />
      </main>
      <Footer data-id="element-766" data-mp="3986tj21aatg2" />
    </div>;
}